'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dCredentials$002dView$0024$0024anon$002455 from "./presto.-Credentials-View$$anon$55.js";
import * as $j_presto$002e$002dCredentials$002dView$0024$0024anon$002456 from "./presto.-Credentials-View$$anon$56.js";
import * as $j_presto$002e$002dCredentials$002dView$0024$0024anon$002457 from "./presto.-Credentials-View$$anon$57.js";
import * as $j_presto$002e$002dCredentials$002dView$0024$0024anon$002458 from "./presto.-Credentials-View$$anon$58.js";
import * as $j_presto$002e$002dCredentials$002dView$0024$0024anon$002459 from "./presto.-Credentials-View$$anon$59.js";
var $p;
/** @constructor */
function $c_Lpresto_CredentialsView$$anon$54(outer) {
  this.aGt = null;
  this.aGr = null;
  this.aGs = false;
  this.aGp = null;
  this.aGq = false;
  this.aGu = false;
  this.aGv = false;
  if ((outer === null)) {
    throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_NullPointerException__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_NullPointerException());
  }
  this.aGt = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_CredentialsView$$anon$54 as $c_Lpresto_CredentialsView$$anon$54 };
$p = $c_Lpresto_CredentialsView$$anon$54.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_CredentialsView$$anon$54;
/** @constructor */
function $h_Lpresto_CredentialsView$$anon$54() {
}
export { $h_Lpresto_CredentialsView$$anon$54 as $h_Lpresto_CredentialsView$$anon$54 };
$h_Lpresto_CredentialsView$$anon$54.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.ac = (function() {
  return this.aGt;
});
$p.t = (function() {
  if ((!this.aGs)) {
    this.aGr = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("BySeed", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("ByTfa", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("BySiteAndGroup", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("ByDocument", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()))));
    this.aGs = true;
  }
  return this.aGr;
});
$p.ad = (function() {
  if ((!this.aGq)) {
    this.aGp = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(new $j_presto$002e$002dCredentials$002dView$0024$0024anon$002455.$c_Lpresto_CredentialsView$$anon$55(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(new $j_presto$002e$002dCredentials$002dView$0024$0024anon$002456.$c_Lpresto_CredentialsView$$anon$56(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(new $j_presto$002e$002dCredentials$002dView$0024$0024anon$002457.$c_Lpresto_CredentialsView$$anon$57(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(new $j_presto$002e$002dCredentials$002dView$0024$0024anon$002458.$c_Lpresto_CredentialsView$$anon$58(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()))));
    this.aGq = true;
  }
  return this.aGp;
});
$p.v = (function() {
  if ((!this.aGv)) {
    this.aGu = true;
    this.aGv = true;
  }
  return this.aGu;
});
$p.acn = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeSum__I__O__Lio_circe_JsonObject(this, new $j_presto$002e$002dCredentials$002dView$0024$0024anon$002459.$c_Lpresto_CredentialsView$$anon$59().aeq(a), a);
});
$p.ab = (function(a) {
  return this.acn(a);
});
var $d_Lpresto_CredentialsView$$anon$54 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_CredentialsView$$anon$54, "presto.CredentialsView$$anon$54", ({
  Gj: 1,
  a: 1,
  j: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_CredentialsView$$anon$54 as $d_Lpresto_CredentialsView$$anon$54 };
//# sourceMappingURL=presto.-Credentials-View$$anon$54.js.map
